import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import WhatItDoes from './pages/WhatItDoes';
import Subscription from './pages/Subscription';
import History from './pages/History';
import HowItWorks from './pages/HowItWorks';
import News from './pages/News';
import SaveLogo from './components/SaveLogo';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="what-it-does" element={<WhatItDoes />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="how-it-works" element={<HowItWorks />} />
        <Route path="history" element={<History />} />
        <Route path="news" element={<News />} />
        <Route path="save-logo" element={<SaveLogo />} />
        <Route path="*" element={<Navigate to="/\" replace />} />
      </Route>
    </Routes>
  );
}

export default App;